import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent }          from './app/app.component';
import { createAppConfig }       from './app/app.config';
import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig }            from './app/auth/auth-config';

/**
 * MSAL 3.x requires the PublicClientApplication to be fully initialized
 * (via initialize()) BEFORE Angular bootstraps. Providing an un-initialized
 * instance causes the app to hang on a blank page.
 */
const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
  bootstrapApplication(AppComponent, createAppConfig(msalInstance))
    .catch((err) => console.error(err));
});
